import { z } from "zod";

export const agentProfileSchema = z.object({
  userId: z.string(),
  name: z.string(),
  email: z.string().optional(),
  phone: z.string().optional(),
  qualification: z.string().optional(),
  profileImageUrl: z.string().nullish(),
  sex: z.enum(["male", "female", "other", "unknown"]).optional(),
  dob: z.string().optional(),
  // Additional fields that the facility-specific endpoint may return
  matchingFacilityQualifications: z.array(z.string()).optional(),
  licensesData: z
    .array(
      z.object({
        _id: z.string(),
        multiState: z.boolean(),
        expiresAt: z.string().nullish(),
        qualification: z.string(),
        state: z.string(),
      })
    )
    .optional(),
});

export type AgentProfile = z.infer<typeof agentProfileSchema>;

export type WorkerSex = NonNullable<AgentProfile["sex"]>;

export interface UpdateWorkerParams {
  agentId: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  rate?: number;
  locations?: string[];
  salesforceId?: string;
  availNote?: string;
  fullSocialSecurityNumber?: string;
  profileVideoUrl?: string;
  performedBy?: string;
  isTestAccount?: boolean;
  qualification?: string;
  adminUserId?: string;
  licensedStates?: string[];
  licenseExpires?: string;
  note?: string;
  experience?: string[];
  experienceType?: string;
  dob?: string;
  employmentStatus?: string;
  sex?: WorkerSex;
}
